module.exports = __webpack_public_path__ + "img/s2.4182f72c.png";